import React from "react";

import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import * as RadixTabs from "@radix-ui/react-tabs";
import clsx from "clsx";
import defaultStyles from "./Tabs.module.scss";

const COMPONENT_KEY = CoreUiComponents.Tabs;
export const Tabs = ({
  className,
  children,
  ...restProps
}: React.ComponentPropsWithRef<typeof RadixTabs.Root>) => {
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  const root = clsx(block, className);

  return (
    <RadixTabs.Root className={root} {...restProps}>
      {children}
    </RadixTabs.Root>
  );
};

export const TabsList = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithRef<typeof RadixTabs.List>) => {
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);
  return (
    <RadixTabs.List className={clsx(cn("list"), className)} {...props}>
      {children}
    </RadixTabs.List>
  );
};

export const TabsTrigger = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithRef<typeof RadixTabs.Trigger>) => {
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);
  return (
    <RadixTabs.Trigger className={clsx(cn("trigger"), className)} {...props}>
      {children}
    </RadixTabs.Trigger>
  );
};

export const TabsContent = ({
  className,
  children,
  ...props
}: React.ComponentPropsWithRef<typeof RadixTabs.Content>) => {
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);
  return (
    <RadixTabs.Content className={clsx(cn("content"), className)} {...props}>
      {children}
    </RadixTabs.Content>
  );
};
